<template>
  <main class="main">
    <section
      class="w-half container-first-section"
      :class="{ 'd-none': isMobileBreakpoint }"
    >
      <div>
        <v-icon
          @click="handleBack"
          class="close-icon"
          size="24"
          color="grey"
          style="cursor: pointer"
        >
          mdi-arrow-left
        </v-icon>
      </div>
      <div class="container-title">
        <img
          width="66px"
          height="40px"
          :src="require('@/assets/panda-brand-ia.png')"
        />
        <h1 class="body-bold-small mt-4">
          {{ workflowTexts.title }}
        </h1>
        <p
          class="body-regular-smaller neutral-40-light--text text-center"
          v-html="workflowTexts.subtitle"
        ></p>
      </div>
    </section>
    <section
      class="container-second-section d-flex w-full flex-column justify-space-between"
      :class="{
        'w-half': !isMobileBreakpoint,
        'height-full-mobile': isMobileBreakpoint,
        'width-full-mobile': isMobileBreakpoint,
      }"
    >
      <div class="d-flex flex-column">
        <header class="d-flex justify-space-between pa-6">
          <div class="d-flex flex-column">
            <span class="body-bold-base">{{
              $t('message.pages.pandaAssist.createModal.purchaseSummary')
            }}</span>
            <a
              target="_blank"
              type="secondary"
              size="xsmall"
              :href="
                $t('message.ai.aiWorkFlowChargeModal.billingRulesInfoHref')
              "
            >
              {{ $t('message.ai.aiWorkFlowChargeModal.knowMoreForBilling') }}

              <v-icon size="12">mdi-open-in-new</v-icon>
            </a>
          </div>
          <div>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </header>
        <v-divider class="w-full"></v-divider>
        <div class="videos-list-container">
          <div
            v-for="video in videos"
            :key="video.title"
            class="container-list-items pa-6"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" size="16" style="color: #7283f3"
                >panda-video</v-icon
              >
              <span
                class="body-bold-smaller neutral-20-dark--text"
                style="
                  display: inline-block;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 90%;
                "
              >
                {{ video.title }}
              </span>
            </div>
            <div class="container-list-item mt-2 justify-space-between">
              <span class="body-regular-smaller" v-if="type == 'AiWorkFlow'">
                {{ $t('message.ai.aiWorkFlowChargeModal.quantityBuy') }}
              </span>

              <div
                style="width: 50%; display: grid"
                v-else
                :key="isMobileBreakpoint ? 'mobile' : 'desktop'"
              >
                <div class="d-flex align-center">
                  <template v-if="type === 'Subtitle'">
                    <span class="body-regular-small neutral-30-base--text">
                      {{ itemsToBuy.length }}x
                      {{
                        itemsToBuy.length > 1
                          ? $t('message.pages.video.subtitles')
                          : $t('message.pages.video.subtitle')
                      }}
                    </span>
                  </template>

                  <template v-else-if="type === 'Dubbing'">
                    <span class="body-regular-small neutral-30-base--text">
                      {{ itemsToBuy.length }}x
                      {{
                        itemsToBuy.length > 1
                          ? $t('message.ai.dubbings.dubbings')
                          : $t('message.ai.dubbings.dubbing')
                      }}
                    </span>

                    <v-tooltip bottom :disabled="tech !== 'heygen'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-tag
                          v-if="type === 'Dubbing' && !isMobileBreakpoint"
                          v-bind="attrs"
                          v-on="on"
                          type="default"
                          size="xsmall"
                          class="ml-2"
                        >
                          <span
                            class="body-regular-smaller brand-20-darkest--text"
                          >
                            {{ techLabel }}
                          </span>
                        </v-tag>
                      </template>
                      <span style="white-space: pre-line">
                        {{
                          $t(
                            'message.ai.dubbings.selectDubbingTech.dubbingLipSyncTooltip'
                          )
                        }}
                      </span>
                    </v-tooltip>
                  </template>
                </div>

                <span class="body-regular-smaller neutral-40-light--text">
                  ({{ itemsToBuy.join(', ') }})
                </span>
              </div>

              <div class="d-flex">
                <v-tag
                  v-if="type !== 'Dubbing' || !isMobileBreakpoint"
                  type="neutral"
                  class="ml-3"
                  size="xsmall"
                  style="display: inline-block"
                >
                  {{ formatDuration(video.length) }}
                </v-tag>
                <v-tag
                  v-if="type !== 'Dubbing' || !isMobileBreakpoint"
                  type="neutral"
                  class="ml-2"
                  size="xsmall"
                >
                  {{ creditChargeValuePerMinute }}
                </v-tag>

                <span class="body-regular-smaller d-flex ml-2">
                  {{ video.price_per_video || totalPrice }}
                  <v-icon class="creditsIcon ml-1" size="16"
                    >panda-ia-credits</v-icon
                  >
                </span>
              </div>
            </div>

            <div
              v-if="type === 'Dubbing' && isMobileBreakpoint"
              class="d-flex mt-2"
            >
              <v-tooltip bottom :disabled="tech !== 'heygen'">
                <template v-slot:activator="{ on, attrs }">
                  <v-tag v-bind="attrs" v-on="on" type="default" size="xsmall">
                    <span class="body-regular-smaller brand-20-darkest--text">
                      {{ techLabel }}
                    </span>
                  </v-tag>
                </template>
                <span style="white-space: pre-line">
                  {{
                    $t(
                      'message.ai.dubbings.selectDubbingTech.dubbingLipSyncTooltip'
                    )
                  }}
                </span>
              </v-tooltip>
              <v-tag type="neutral" class="ml-3" size="xsmall">
                {{ formatDuration(video.length) }}
              </v-tag>
              <v-tag type="neutral" class="ml-2" size="xsmall">
                {{ creditChargeValuePerMinute }}
              </v-tag>
            </div>
          </div>
        </div>
      </div>
      <div class="container-resume">
        <div>
          <div class="d-flex justify-space-between">
            <span class="body-bold-base">Total</span>
            <span class="body-bold-base d-flex"
              >{{ totalPrice }}

              <v-icon class="creditsIcon ml-2" size="16"
                >panda-ia-credits</v-icon
              >
            </span>
          </div>
          <div class="d-flex justify-space-between mt-2">
            <span class="body-regular-smaller neutral-40-light--text">{{
              $t('message.pages.pandaAssist.createModal.remainingBalance')
            }}</span>
            <span
              class="body-regular-smaller neutral-40-light--text d-flex"
              :class="{ 'feedback-danger--text': remainingCredits < 0 }"
              ><span v-once>{{ remainingCredits }}</span>
              <v-icon
                class="creditsIcon ml-2"
                size="16"
                :class="{ 'feedback-danger--text': remainingCredits < 0 }"
                >panda-ia-credits</v-icon
              >
            </span>
          </div>
        </div>
        <div class="d-flex">
          <base-btn type="tertiary" @click="handleBack" :disabled="loading">{{
            $t('message.actions.return')
          }}</base-btn>
          <base-btn
            v-if="!hasNoEnoughCredits && remainingCredits >= 0"
            style="flex: 1"
            class="ml-2"
            type="primary"
            :loading="loading"
            :disabled="loading"
            @click="generate"
          >
            {{ workflowTexts.button }}</base-btn
          >
          <base-btn
            v-else
            :disabled="loading"
            style="flex: 1"
            class="ml-2"
            type="primary"
            @click="handleGoChargeCredits"
          >
            {{ $t('message.ai.hasNoEnoughCredits') }}</base-btn
          >
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import i18n from '@/translations/lang'
export default {
  name: 'CheckoutAiTemplate',
  props: {
    type: {
      type: String,
      required: true,
    },
    videos: {
      type: Array,
      required: true,
    },
    remainingCredits: {
      type: Number,
    },
    totalPrice: {
      type: Number,
    },
    itemsToBuy: {
      type: Array,
      default: () => [],
    },
    hasNoEnoughCredits: {
      type: Boolean,
    },
    isBatch: {
      type: Boolean,
    },
    tech: {
      type: String,
    },
    existingSubtitlesImpacted: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    workflowTexts() {
      if (this.type === 'Subtitle') {
        return {
          title: i18n.t('message.ai.subtitles.checkout.title'),
          subtitle: i18n.t('message.ai.subtitles.checkout.description'),
          button: i18n.t('message.ai.subtitles.checkout.button'),
        }
      } else if (this.type === 'Dubbing') {
        return {
          title: i18n.t('message.ai.dubbings.checkout.title'),
          subtitle: i18n.t('message.ai.dubbings.checkout.description'),
          button: i18n.t('message.ai.dubbings.checkout.button'),
        }
      }
      return {
        title: i18n.t('message.ai.aiWorkFlowChargeModal.checkoutTitle'),
        subtitle: i18n.t('message.ai.aiWorkFlowChargeModal.checkoutSubtitle'),
        button: i18n.t('message.ai.aiWorkFlowChargeModal.purchasedPackageAI'),
      }
    },
    techLabel() {
      if (this.tech === 'heygen') {
        return this.$t('message.ai.dubbings.selectDubbingTech.dubbingLipSync')
      }
      return this.$t('message.ai.dubbings.selectDubbingTech.dubbingAI')
    },
    creditChargeValuePerMinute() {
      if (this.type === 'Subtitle') {
        return this.$t(
          'message.pages.pandaAssist.createModal.creditChargeValue'
        )
      }
      const value = this.tech === 'heygen' ? 10 : 2
      const plural = value > 1 ? 's' : ''
      return this.$t('message.ai.creditChargeValuePerMinute', {
        credits: value,
        plural,
      })
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_CREDITS']),
    ...mapActions('user', ['forceUpdateCreditsBalance']),
    formatDuration(seconds) {
      const allSeconds = this.itemsToBuy.length
        ? seconds * this.itemsToBuy.length
        : seconds
      const totalSeconds = Math.floor(allSeconds)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const secs = totalSeconds % 60

      let result = ''
      if (hours > 0) result += `${hours}h`
      if (minutes > 0 || hours > 0) result += `${minutes}min`
      if (secs > 0) result += `${secs}s`

      return result
    },
    handleClose() {
      this.$root.$emit(`close${this.type}Modal`)
    },
    handleBack() {
      if (
        this.existingSubtitlesImpacted?.length > 0 &&
        this.type === 'Dubbing'
      ) {
        this.$root.$emit('handleExistingSubtitlesScreen')
      } else {
        this.$root.$emit(`back${this.type}Modal`)
      }
    },
    generate() {
      this.loading = true
      this.forceUpdateCreditsBalance(this.remainingCredits)
      if (!this.isBatch) return this.$root.$emit(`generate${this.type}`)
      this.$emit(`generate${this.type}Batch`)
    },
    handleGoChargeCredits() {
      this.loading = true
      this.$root.$emit('creditsBuyModal', {
        type: this.type,
        remainingCredits: this.remainingCredits,
        isBatch: this.isBatch,
      })
    },
  },
  beforeDestroy() {
    this.loading = false
  },
  mounted() {
    this.loading = false
    this.$root.$on('generateByPayments', () => {
      this.generate()
    })
    this.$root.$on('closeCreditsBuyModal', () => {
      this.loading = false
    })
  },
}
</script>

<style scoped lang="scss">
.height-full-mobile {
  height: 100dvh;
  overflow: auto;
}
.width-full-mobile {
  width: 100%;
}
.main {
  display: flex;
  height: 637px;
  background: varFigma(neutral-background);
}
.w-half {
  width: 50%;
}
.container-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 95%;
}
.text-center {
  text-align: center;
}
.container-resume {
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  align-self: stretch;
  background: varFigma(neutral-99);
}
.container-first-section {
  padding-left: 24px;
  padding-top: 24px;
  background: varFigma(neutral-background);
}
.container-second-section {
  background: varFigma(neutral-100-white);
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
}
.creditsIcon {
  color: varFigma(brand-70);
}
.container-list-item {
  display: flex;
  align-items: center;
}
.videos-list-container {
  max-height: 390px;
  overflow: auto;
}
@media screen and (max-height: 700px) {
  .main {
    height: 85vh;
  }
}
@media screen and (max-width: 768px) {
  .container-list-item {
    align-items: flex-end;
  }
  .videos-list-container {
    max-height: calc(100vh - 250px);
  }
}
</style>
